module.exports = __webpack_public_path__ + "static/media/bulk-quote.20ae1610.png";